/**
 * Video editor preset motion speed (Ken Burns / camera presets on the animation lane).
 * Stored on editor snapshot as editor_animation_speed (0 = stopped … 12 = very fast at 100% slider).
 */

import {
  MOTION_SPEED_SLIDER_MAX,
  MOTION_SPEED_SLIDER_MIN,
  clampMotionRate,
  motionRateFromSlider,
  motionSliderFromRate,
} from './motionSpeedScale';

export const EDITOR_ANIMATION_SPEED_MIN = 0;
/** Full slider (100%) — continuous fast preset motion (ping-pong cycles). */
export const EDITOR_ANIMATION_SPEED_MAX = 24;
export const EDITOR_ANIMATION_SPEED_DEFAULT = 1;

export function clampEditorAnimationSpeed(value) {
  return clampMotionRate(value, EDITOR_ANIMATION_SPEED_MAX);
}

export function editorAnimationSpeedToSlider(speed) {
  return motionSliderFromRate(speed, EDITOR_ANIMATION_SPEED_MAX);
}

export function editorAnimationSpeedFromSlider(sliderValue) {
  return motionRateFromSlider(sliderValue, EDITOR_ANIMATION_SPEED_MAX);
}

export function editorAnimationSpeedFromSnapshot(editor = {}) {
  const raw = editor?.editor_animation_speed ?? editor?.editorAnimationSpeed;
  return raw == null ? EDITOR_ANIMATION_SPEED_DEFAULT : clampEditorAnimationSpeed(raw);
}

export function editorAnimationSpeedLabel(speed) {
  const r = clampEditorAnimationSpeed(speed);
  if (r <= 0) return 'Stopped';
  const slider = editorAnimationSpeedToSlider(r);
  if (slider >= MOTION_SPEED_SLIDER_MAX) return '100% · Very fast';
  if (slider >= 80) return `${slider}% · Fast`;
  if (slider <= 3) return `${slider}% · Floating`;
  if (slider <= 15) return `${slider}% · Slow`;
  return `${slider}%`;
}

export { MOTION_SPEED_SLIDER_MIN, MOTION_SPEED_SLIDER_MAX };
